import React from 'react';
export const Loading = () => {
    return (React.createElement("div", { className: "loader-container" },
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement("div", { className: "loader" },
                    React.createElement("div", { className: "child" }))),
            React.createElement("li", null,
                React.createElement("div", { className: "text" })))));
};
